import { del } from 'vue'

export default {
  search: 'Search',
  searchPlaceholder: 'AWB, Order Number, Sender / Receiver',
  dateRange: 'Date Range',
  dataNotFound: 'Data Not Found!',
  tab: {
    all: 'All',
    ongoing: 'Ongoing',
    unpaid: 'Unpaid',
    completed: 'Completed',
    complain: 'Complain',
    draft: 'Draft'
  },
  addOrder: 'Add Order',
  uploadOrder: 'Upload Order',
  downloadTemplateOrder: 'Download',
  show: 'Show',
  from: 'from',
  uploadOrderCard: {
    editButton: 'Edit',
    deleteButton: 'Delete'
  },
  draftOrderCard: {
    continueOrder: 'Continue Order'
  },
  orderCard: {
    orderNumber: 'Order Number',
    awbPartner: 'AWB Partner',
    moreDetail: 'More Detail',
    senderName: 'Sender Name',
    senderAddress: 'Sender Address',
    detailPickup: 'Detail Pickup',
    receiverName: 'Receiver Name',
    receiverAddress: 'Receiver Address',
    detailShipping: 'Detail Shipping',
    weight: 'Weight',
    goodsCategory: 'Goods Category',
    price: 'Price'
  },
  orderDetail: {
    awbPartner: 'AWB Partner',
    submitComplaint: 'Submit Complaint',
    continuePayment: 'Continue Payment',
    weightTypePackage: 'Weight and Type of Package',
    weight: 'Weight',
    type: 'Type of Package',
    deliveryService: 'Delivery Service',
    serviceName: 'Service Name',
    serviceType: 'Service Type',
    senderInfo: 'Sender Information',
    senderName: 'Sender Name',
    senderPhone: 'Sender Phone',
    senderAddress: 'Sender Address',
    pod: "The sender's info address is reused for POD delivery.",
    receiverInfo: 'Receiver Information',
    receiverName: 'Receiver Name',
    receiverPhone: 'Receiver Phone',
    receiverAddress: 'Receiver Address',
    packagePhoto: 'Package Photo',
    photoNotAvailable: 'Photo is not available',
    priceAdjustment: 'Price Adjustment',
    oldWeight: 'Old Weight',
    newWeight: 'New Weight',
    oldDimension: 'Old Dimension',
    newDimension: 'New Dimension',
    oldPrice: 'Old Price',
    newPrice: 'New Price',
    markAsPaid: 'Mark as Paid',
    markAsPaidConfirmTitle: 'Mark as Paid Confirmation',
    markAsPaidConfirmDesc: 'Are you sure you want to mark this price adjustment as paid? The status will be changed to Payment Under Verification.',
    paymentAccountInfo: 'Payment Account Information',
    accountName: 'Account Name',
    accountBank: 'Bank',
    accountNumberLabel: 'Account Number',
    paymentInfo: 'Payment Information',
    status: 'Status',
    paymentType: 'Payment Type',
    bank: 'Bank',
    accountNumber: 'Account Number',
    deliveryStatus: 'Delivery Status',
    statusChange: 'Status Change',
    statusDesc: 'Ensure that the address information and package contents comply with the specified shipping conditions. Process changes cannot be made.',
    underpaid: 'Underpaid',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    additionalPrice: 'Additional Price',
    other: 'Other',
    deliveryLabel: 'Delivery Label',
    downloadLabelText: 'Would you like to download the shipping label??'
  },
  createOrder: {
    stepOne: {
      title: 'Step 1',
      desc: 'Package Delivery Data',
      dataNotFound: 'Sorry, data not found!',
      senderInfo: 'Sender Infromation',
      senderAddress: 'Sender Address',
      senderAddressPlaceholder: 'Please input sender address',
      searchSenderPlaceholder: 'Search sender address...',
      detailAddress: 'Detail Address',
      mainAddress: 'Main Address',
      addAddress: 'Add Address',
      selectAddress: 'Select Address',
      updateAddress: 'Update Address',
      manualInput: 'Manual Input',
      receiverInfo: 'Receiver Information',
      receiverName: 'Receiver Name',
      receiverNamePlaceholder: 'Please input receiver name',
      receiverPhone: 'Receiver Phone Number',
      receiverPhonePlaceholder: 'Please input receiver phone number',
      receiverDistrict: 'Receiver District / Subdistrict / Postal Code',
      receiverDistrictPlaceholder: 'Receiver District / Subdistrict / Postal Code',
      receiverAddress: 'Receiver Address',
      receiverAddressPlaceholder: 'Plase input complete receiver address (example: jln. Merpati No. 35, RT/RW, Kelurahan X, Kecamatan Y, Kota/Kabupaten Z, 12345)',
      serviceType: 'Service Type & Package',
      pickupDate: 'Pickup Date',
      pickupTime: 'Pickup Time',
      pickupTimePlaceholser: 'Select pickup time',
      packageType: 'Package Type',
      packageTypePlaceholder: 'Select package type',
      packageSize: 'Package Size',
      deliveryService: 'Delivery Service',
      pod: 'Logistics availability will adjust and support POD delivery.',
      cancel: 'Cancel',
      next: 'Next',
      modal: {
        customPackage: 'Custom Paket',
        weight: 'Package Weight',
        weightPlaceholder: 'Please input package weight',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        cancel: 'Cancel',
        submit: 'Submit'
      },
      receiverAddressForm: {
        title: 'Select Delivery Location',
        receiverAddress: 'Receiver Address',
        receiverAddressPlaceholder: 'Search receiver address...',
        cancel: 'Cancel',
        save: 'Save'
      }
    },
    stepTwo: {
      title: 'Langkah 2',
      desc: 'Logistic data',
      show: 'Show',
      unavailableService: 'Service is unavailable',
      deliveryService: 'delivery services',
      deliveryServiceTitle: 'Delivery Services',
      minimumWeight: 'Minimum shipping weight',
      maximumWeight: 'Maximum shipping weight',
      adjustWeight: 'Please adjust the weight of the goods.',
      noService: 'No delivery service available.',
      insurance: 'Shipping Insurance',
      goodsValue: 'Price of Insured Goods',
      goodsValuePlaceholder: 'Goods value',
      insuranceCost: 'Shipping insurance costs',
      pickupLater: 'Pickup Later',
      pickupLaterText: 'If you place an order after 14:00, it may be picked up the next day.',
      senderInformation: 'Sender Information',
      senderAddress: 'Sender Address',
      senderDetailAddress: 'Detail',
      receiverInformation: 'Receiver Information',
      receiverAddress: 'Receiver Address',
      weight: 'Item Weight',
      packageType: 'Package Category',
      pod: "The delivery note (POD) will be sent to the sender's address.",
      back: 'Back',
      next: 'Next',
      cutOffNote: 'Your order may be eligible for pickup on the next day as it has passed the processing cutoff time.'
    },
    stepThree: {
      title: 'Step 3',
      desc: 'Confirmation',
      detail: 'Detail',
      shippingDestination: 'Shipping Destination',
      serviceType: 'Service Type',
      logistic: 'Logistic',
      goodsCategory: 'Goods Category',
      weight: 'Shipping Weight',
      pickupService: 'Pickup Service',
      pickupTime: 'Pickup Time',
      pod: 'Delivery of travel documents (POD)',
      podExist: 'Exist',
      goodsValue: 'Goods Value',
      shippingCost: 'Shipping Cost',
      shippingCostPod: 'Shipping Cost (POD)',
      pickupCost: 'Pickup Cost',
      shippingCostDiscount: 'Shipping Cost Discount',
      insuranceCost: 'Insurance Cost',
      totalCost: 'Total Cost',
      senderInformation: 'Sender Information',
      senderAddress: 'Sender Address',
      podNote: "The delivery note (POD) will be sent to the sender's address.",
      receiverInformation: 'Receiver Information',
      receiverAddress: 'Receiver Address',
      itemWeight: 'Item Weight',
      details: 'Details',
      back: 'Back',
      pay: 'Pay',
      draft: 'Save as Draft'
    }
  }
}
